export enum ECpdDraftStatus {
  init = 'init',
  success = 'success',
  fail = 'fail',
  loading = 'loading',
}

export interface ICPDState {
  isCpdAvailable: boolean;
  cpdDraftId?: number;
  cpdDraftStatus: ECpdDraftStatus;
}
